import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./PagoFinish.css";
import { consultarResultadoPago } from "../../services/procesoMatricula/pagoPasarela";

const PagoFinish = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [estado, setEstado] = useState("cargando");
  const [datosPago, setDatosPago] = useState(null);
  const [datosPagador, setDatosPagador] = useState(null);
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      setEstado("failure");
      return;
    }

    const consultarPago = async () => {
      try {
        const data = await consultarResultadoPago(token);

        console.log("=================================");
        console.log("🔵 RESPUESTA COMPLETA DEL PAGO:");
        console.log(data);
        console.log("🔵 data.data:");
        console.log(data?.data);
        console.log("=================================");
        
        setDatosPago(data);

        const datosPagadorGuardados =
          localStorage.getItem("datos_pagador_pago");

        if (datosPagadorGuardados) {
          try {
            const pagador = JSON.parse(datosPagadorGuardados);

            console.log(
              "[PagoFinish DEBUG] Datos del pagador:",
              pagador
            );

            setDatosPagador(pagador);
          } catch (error) {
            console.error(
              "[PagoFinish ERROR] No se pudieron leer los datos del pagador:",
              error
            );
          }
        }

        const estadoPago = String(data.estado || "").toUpperCase().trim();
        const operacionExitosa =
          data.success === true || data.success === "true" || data.success === 1;

        if (operacionExitosa && estadoPago === "PAGADO") {
          setEstado("success");
        } else {
          setEstado("failure");
        }
      } catch (error) {
        console.error("Error consultando pago:", error);
        setEstado("failure");
      }
    };

    consultarPago();
  }, [token]);


  const handleContinuar = () => {
    localStorage.removeItem("datos_pagador_pago");
  
    navigate("/matricula?autoStart=true");
  };
  

  if (estado === "cargando") {
    return (
      <div className="pago-full-screen">
        <div className="pago-loader-box">
          <div className="pago-spinner"></div>
          <p>Validando transacción...</p>
        </div>
      </div>
    );
  }

  if (estado !== "success") {
    return (
      <div className="pago-full-screen">
        <div className="pago-card-clon" style={{ padding: '40px', textAlign: 'center' }}>
          <h2 style={{ color: '#8c1d3a' }}>Pago no confirmado</h2>
          <p>No pudimos validar su pago. Por favor, regrese e intente de nuevo.</p>
          <button className="clon-btn-finish" onClick={() => navigate("/matricula")}>Regresar</button>
        </div>
      </div>
    );
  }

  const pagador = datosPagador || {};

  return (
    <div className="pago-full-screen">
      <div className="pago-card-clon">
        {/* HEADER */}
        <header className="clon-header">
          <div className="clon-header-left">
            <div className="clon-logo-grid">
              <span></span><span></span><span></span><span></span>
            </div>
            <div className="clon-header-titles">
              <h1>UPCH</h1>
              <p>Datos de pago obtenidos exitosamente</p>
              <p>Operación procesada exitosamente</p>
            </div>
          </div>
          <div className="clon-badge">
            <svg viewBox="0 0 16 16" width="14" height="14">
              <path fill="currentColor" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>
            PAGADO
          </div>
        </header>

        {/* MONTO */}
        <section className="clon-monto-section">
          <span className="clon-label-monto">MONTO PAGADO</span>
          <div className="clon-valor-monto">
            {datosPago.moneda === "PEN" ? "S/ " : "$ "}
            {parseFloat(datosPago.monto || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
          </div>
          <span className="clon-moneda-text">Moneda: {datosPago.moneda === "PEN" ? "Soles" : "Dólares"}</span>
        </section>

        {/* DETALLE OPERACION */}
        <section className="clon-section">
          <h2 className="clon-section-title">
            <svg viewBox="0 0 16 16" width="15" height="15" style={{ marginRight: '6px' }}><path fill="currentColor" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" /></svg>
            Detalle de la Operación
          </h2>
          <div className="clon-grid clon-3-col">
            <div className="clon-item"><label>MÉTODO DE PAGO</label><strong>{datosPago.metodo_pago || "CARD"}</strong></div>
            <div className="clon-item"><label>MARCA</label><strong>{datosPago.marca_tarjeta || "VISA"}</strong></div>
            <div className="clon-item"><label>TARJETA</label><strong>{datosPago.tarjeta_enmascarada || "****"}</strong></div>
          </div>
          <div className="clon-grid clon-2-col" style={{ marginTop: '10px' }}>
            <div className="clon-item"><label>CÓDIGO DE AUTORIZACIÓN</label><strong>{datosPago.codigo_autorizacion}</strong></div>
            <div className="clon-item"><label>FECHA DE AUTORIZACIÓN</label><strong>{datosPago.fecha_autorizacion}</strong></div>
          </div>
        </section>

        {/* DATOS DEL PAGADOR */}
        <section className="clon-section">
          <h2 className="clon-section-title">
            <svg viewBox="0 0 16 16" width="15" height="15" style={{ marginRight: '6px' }}><path fill="currentColor" d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4" /></svg>
            Datos del Pagador
          </h2>
          <div className="clon-grid clon-3-col">
           
            <div className="clon-item">
              <label>NOMBRE COMPLETO</label>
              <strong>
                {`${pagador.nombre_completo || ""} ${
                  pagador.apellido_paterno || ""
                } ${
                  pagador.apellido_materno || ""
                }`}
              </strong>
            </div>

            
            <div className="clon-item">
              <label>DOCUMENTO</label>
              <strong>
                {`${pagador.tipo_documento || "DNI"} ${
                  pagador.numero_documento || ""
                }`}
              </strong>
            </div>

            <div className="clon-item">
              <label>CELULAR</label>
              <strong>
                {pagador.numero_celular || ""}
              </strong>
            </div>
          </div>
          <div className="clon-item">
            <label>CORREO ELECTRÓNICO</label>
            <strong>
              {pagador.correo || ""}
            </strong>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="clon-footer">
          <div className="clon-footer-info">
            <svg viewBox="0 0 16 16" width="12" height="12" style={{ marginRight: '4px' }}><path fill="currentColor" d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16M9.283 4.002V12H7.971V5.338h-.065L6.072 6.656V5.385l1.899-1.383z" /></svg>
            Esta constancia certifica que la transacción fue procesada satisfactoriamente.
          </div>
      
          <div className="clon-actions no-print">
            <button className="clon-btn-print" onClick={() => window.print()}>Imprimir</button>
            <button className="clon-btn-finish" onClick={handleContinuar}>Continuar</button>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default PagoFinish;